export default "__VITE_ASSET__CqQv2prF__"